(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4928],{

/***/ 39659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SelectWrapper; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87536);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65138);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68777);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96861);
/* harmony import */ var components_common_text_field__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80367);
/* harmony import */ var styles_breakpoints__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20881);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);
/* eslint-disable react/no-unused-prop-types */










var options = [{
  value: 'buy',
  label: 'Buyer'
}, {
  value: 'sell',
  label: 'Seller'
}];

function Select(_ref) {
  var label = _ref.label,
      name = _ref.name,
      control = _ref.control,
      error = _ref.error,
      initialValue = _ref.initialValue;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SelectWrapper, {
    children: [label && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_common_text_field__WEBPACK_IMPORTED_MODULE_3__/* .TextFieldLabel */ .pU, {
      "data-testid": "select-label",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("label", {
        htmlFor: name,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          type: "mode2",
          fw: "light",
          children: label
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_common_text_field__WEBPACK_IMPORTED_MODULE_3__/* .TextFieldInput */ .Nl, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .Controller */ .Qr, {
        defaultValue: initialValue,
        control: control,
        name: name,
        render: textController(error)
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_common_text_field__WEBPACK_IMPORTED_MODULE_3__/* .TextFieldError */ .ns, {
      "data-testid": "select-error",
      children: (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        type: "mode2",
        fw: "medium",
        children: error.message
      })
    })]
  });
}

function textController(error) {
  return function renderTextController(_ref2) {
    var _ref2$field = _ref2.field,
        onChange = _ref2$field.onChange,
        value = _ref2$field.value,
        onBlur = _ref2$field.onBlur;

    function handleChange(option) {
      onChange(option === null || option === void 0 ? void 0 : option.value);
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
      options: options,
      placeholder: "Choose as option",
      onChange: handleChange,
      onBlur: onBlur,
      value: options.filter(function (option) {
        return value === null || value === void 0 ? void 0 : value.includes(option.value);
      }),
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('select-container', {
        invalid: error
      })
    });
  };
}

var SelectWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "select__SelectWrapper",
  componentId: "sc-1tnonzr-0"
})(["width:100%;margin-top:24px;.select-container{font-family:'Walsheim-Regular';&.invalid{.css-1s2u09g-control{border-color:", ";}}}.css-1s2u09g-control,.css-1pahdxg-control{border-radius:unset;border-width:1px;min-height:55px;box-shadow:unset;}&.styled-select{.select-label{margin-bottom:10px;p{color:", ";}}.select-container{font-family:'Inter',sans-serif;}.react-select__control{height:55px;border:1px solid ", ";border-radius:0;background-color:", ";}.react-select__indicator-separator{display:none;}.react-select__indicator{color:", ";padding:16px;}.react-select__placeholder{color:", ";}.react-select__value-container{padding:13px 20px;}.react-select_{&_option{font-family:'Inter',sans-serif;}&_option--is-selected{background:", ";color:", ";}&_option:hover,&_option--is-focused{background:", ";}&_control--menu-is-open,&_control--is-focused,&_control--is-focused:hover,&_control--menu-is-open:hover{box-shadow:none;border:1px solid ", ";}}@media ", "{.react-select__control{height:51px;}.react-select__value-container{padding:12px 15px;}}}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.red;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.blackPallet6;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.grayPallet19;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.whitePallet3;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.blackPallet6;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grayPallet18;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.grayPallet19;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.blackPallet6;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.grayPallet19;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.green;
}, styles_breakpoints__WEBPACK_IMPORTED_MODULE_4__/* .device.tablet */ .U.tablet);
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(Select));

/***/ }),

/***/ 9769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92680);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





function Typography(_ref) {
  var children = _ref.children,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var propsToPass = _objectSpread(_objectSpread({
    as: (0,lodash__WEBPACK_IMPORTED_MODULE_1__.includes)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .CustomTypographyVariantValues */ .F, props.variant) ? 'p' : props.variant
  }, props), 'as' in props && {
    as: props.as
  });

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Typography */ .Z.Typography, _objectSpread(_objectSpread({}, propsToPass), {}, {
    children: children
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (Typography);

/***/ }),

/***/ 22152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useAppSelector; },
/* harmony export */   "T": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9473);

var useAppDispatch = function useAppDispatch() {
  return (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
};
var useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9;

/***/ }),

/***/ 66598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "useHandleWithGoogle": function() { return /* reexport */ useHandleWithGoogle; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@react-oauth/google/dist/index.esm.js
var index_esm = __webpack_require__(86426);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useRedux.ts
var useRedux = __webpack_require__(22152);
// EXTERNAL MODULE: ./store/slices/auth/index.ts + 1 modules
var auth = __webpack_require__(43685);
// EXTERNAL MODULE: ./lib/axios.ts
var axios = __webpack_require__(5272);
// EXTERNAL MODULE: ./constants/routes.ts
var routes = __webpack_require__(71624);
;// CONCATENATED MODULE: ./lib/mutation/google/hook.ts










var useHandleWithGoogle = function useHandleWithGoogle(_ref) {
  var usagePurpose = _ref.usagePurpose,
      phone = _ref.phone;
  var router = (0,next_router.useRouter)();
  var dispatch = (0,useRedux/* useAppDispatch */.T)();
  var keyRef = (0,react.useRef)('');

  var _useMutation = (0,useMutation/* useMutation */.D)(function (args) {
    return axios/* api.post */.h.post('/auth/google/', args).then(function (res) {
      return res.data;
    });
  }),
      isErrorGoogle = _useMutation.isError,
      errorGoogle = _useMutation.error,
      isLoadingGoogle = _useMutation.isLoading,
      mutateAsync = _useMutation.mutateAsync;

  var _useQuery = (0,useQuery/* useQuery */.a)(['me', keyRef.current], /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref2) {
      var queryKey, _yield$api$get, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              queryKey = _ref2.queryKey;
              _context.next = 3;
              return axios/* api.get */.h.get('/me', {
                headers: {
                  Authorization: "Token ".concat(queryKey[1])
                }
              });

            case 3:
              _yield$api$get = _context.sent;
              data = _yield$api$get.data;
              return _context.abrupt("return", data);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), {
    enabled: !!keyRef.current,
    onSuccess: function onSuccess(data) {
      dispatch((0,auth.addUser)({
        jwt: {
          access: "Token ".concat(keyRef.current),
          refresh: keyRef.current
        },
        data: data
      }));
      router.replace(routes/* HOME_ROUTE */.ef);
    }
  }),
      isErrorMe = _useQuery.isError,
      errorMe = _useQuery.error,
      isFetchingMe = _useQuery.isFetching;

  var handleGoogle = (0,index_esm/* useGoogleLogin */.Nq)({
    onSuccess: function () {
      var _onSuccess = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(codeResponse) {
        var _yield$mutateAsync, key;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return mutateAsync({
                  accessToken: codeResponse.access_token,
                  usagePurpose: usagePurpose,
                  phone: phone
                });

              case 2:
                _yield$mutateAsync = _context2.sent;
                key = _yield$mutateAsync.key;
                keyRef.current = key;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function onSuccess(_x2) {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }(),
    onError: function onError(resErr) {
      console.error(resErr);
    }
  });
  return {
    handleGoogle: handleGoogle,
    loading: isLoadingGoogle || isFetchingMe,
    isError: isErrorMe || isErrorGoogle,
    error: errorMe || errorGoogle
  };
};
;// CONCATENATED MODULE: ./lib/mutation/google/index.ts



/***/ }),

/***/ 699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sign_up; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(68777);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/common/title/index.tsx
var title = __webpack_require__(51951);
// EXTERNAL MODULE: ./components/common/text/index.tsx
var common_text = __webpack_require__(96861);
// EXTERNAL MODULE: ./styles/breakpoints.ts
var breakpoints = __webpack_require__(20881);
// EXTERNAL MODULE: ./utils/validations.ts + 1 modules
var validations = __webpack_require__(87023);
// EXTERNAL MODULE: ./components/common/button/index.tsx
var common_button = __webpack_require__(57456);
// EXTERNAL MODULE: ./hooks/useRedux.ts
var useRedux = __webpack_require__(22152);
// EXTERNAL MODULE: ./store/slices/onboarding/index.ts + 1 modules
var onboarding = __webpack_require__(78671);
;// CONCATENATED MODULE: ./store/slices/onboarding/selector.ts
var onboardingSelector = function onboardingSelector(state) {
  return state.onboardingSlice;
};
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/forms/list-price-form/PriceForm.tsx



/* eslint-disable react/no-unused-prop-types */




















function PriceForm() {
  var dispatch = (0,useRedux/* useAppDispatch */.T)();

  var _useAppSelector = (0,useRedux/* useAppSelector */.C)(onboardingSelector),
      listing = _useAppSelector.listing;

  var _useRouter = (0,next_router.useRouter)(),
      query = _useRouter.query;

  var _useForm = (0,index_esm/* useForm */.cI)({
    mode: 'onChange',
    resolver: (0,yup/* yupResolver */.X)(validations/* listPriceSchema */.Ci)
  }),
      handleSubmit = _useForm.handleSubmit,
      isValid = _useForm.formState.isValid,
      control = _useForm.control;

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch((0,onboarding/* fillListing */.nr)({
                listPrice: Number(data.listPrice),
                agentCommission: Number(data.agentCommission)
              }));
              dispatch((0,onboarding/* changeStep */.sz)('stepConfirm'));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PriceFormHead, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/static/icons/listing-1.svg",
        width: 100,
        height: 100
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(title/* default */.Z, {
        type: "mode3",
        fw: "light",
        className: "price-form-title",
        children: "One Step Closer to"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(title/* default */.Z, {
        type: "mode3",
        fw: "bold",
        className: "price-form-subtitle",
        children: "Selling Your Home"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
        type: "mode4",
        fw: "bold",
        className: "price-form-address",
        children: "\"".concat(query.address, "\"")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
        type: "mode8",
        className: "price-form-info",
        children: "Tell us the asking price and Buyers Commission. You can change these later."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ListPriceForm, {
      onSubmit: handleSubmit(onSubmit),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "list-price-inp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          defaultValue: listing !== null && listing !== void 0 && listing.listPrice ? String(listing === null || listing === void 0 ? void 0 : listing.listPrice) : undefined,
          control: control,
          name: "listPrice",
          render: renderListingPrice
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "agent-com-inp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          defaultValue: listing !== null && listing !== void 0 && listing.agentCommission ? String(listing === null || listing === void 0 ? void 0 : listing.agentCommission) : undefined,
          control: control,
          name: "agentCommission",
          render: renderAgentCommission
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_button/* Button */.z, {
        type: "submit",
        className: "submit",
        disabled: !isValid,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
          type: "mode3",
          children: "Continue"
        })
      })]
    })]
  });
}

function renderListingPrice(_ref2) {
  var _ref2$field = _ref2.field,
      onChange = _ref2$field.onChange,
      name = _ref2$field.name,
      value = _ref2$field.value;

  function handleValueChange(values) {
    var updatedValue = values.value;
    onChange(updatedValue);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_number_format_es/* default */.Z, {
    placeholder: "Asking Price",
    name: name,
    value: value,
    onValueChange: handleValueChange,
    className: classnames_default()({
      valid: Boolean(value)
    }),
    thousandSeparator: true,
    prefix: "$ ",
    maxLength: 10
  });
}

function renderAgentCommission(_ref3) {
  var _ref3$field = _ref3.field,
      onChange = _ref3$field.onChange,
      name = _ref3$field.name,
      value = _ref3$field.value;

  function handleValueChange(values) {
    var updatedValue = values.value;
    onChange(updatedValue);
  }

  function handleIsAllowed(values) {
    var updatedValue = values.value;
    if (Number(updatedValue) <= 10) return true;
    return false;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_number_format_es/* default */.Z, {
    placeholder: "Buyers Agent Commission",
    name: name,
    value: value,
    onValueChange: handleValueChange,
    className: classnames_default()({
      valid: Boolean(value)
    }),
    suffix: " %",
    isAllowed: handleIsAllowed,
    maxLength: 5
  });
}

var PriceFormHead = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PriceForm__PriceFormHead",
  componentId: "sc-1xmydtj-0"
})(["display:flex;flex-direction:column;align-items:center;.price-form{&-title{margin-top:36px;}&-subtitle,&-address{margin:8px 0;}&-info{margin:24px 0;text-align:center;color:", ";}}@media ", "{.price-form{&-title,&-subtitle{font-size:28px;line-height:36px;}}}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.bluePallet1;
}, breakpoints/* device.smallLaptop */.U.smallLaptop);
var ListPriceForm = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "PriceForm__ListPriceForm",
  componentId: "sc-1xmydtj-1"
})([".list-price-inp,.agent-com-inp{margin-top:16px;> input{width:100%;height:70px;text-align:center;color:", ";font-size:18px;line-height:20px;font-family:'Walsheim-Regular';letter-spacing:2px;border:1px solid ", ";background-color:", ";&.valid,&:focus{border:1px solid ", ";background-color:transparent;}}}.submit{margin-top:36px;border-radius:unset;&:disabled{opacity:0.4;}}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.bluePallet1;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.grayPallet5;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.grayPallet5;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.green;
});
/* harmony default export */ var list_price_form_PriceForm = (/*#__PURE__*/(0,react.memo)(PriceForm));
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./lib/axios.ts
var axios = __webpack_require__(5272);
;// CONCATENATED MODULE: ./lib/mutation/sign-up/hook.ts


var useSignUp = function useSignUp() {
  var _useMutation = (0,useMutation/* useMutation */.D)(function (args) {
    return axios/* api.post */.h.post('/auth/register', args).then(function (res) {
      return res.data;
    });
  }),
      isError = _useMutation.isError,
      isLoading = _useMutation.isLoading,
      data = _useMutation.data,
      mutateAsync = _useMutation.mutateAsync,
      error = _useMutation.error;

  return {
    signUp: mutateAsync,
    isError: isError,
    isLoading: isLoading,
    data: data,
    error: error
  };
};
;// CONCATENATED MODULE: ./lib/mutation/sign-up/index.ts


// EXTERNAL MODULE: ./components/common/loader/index.tsx
var loader = __webpack_require__(6035);
// EXTERNAL MODULE: ./components/common/error/index.tsx
var common_error = __webpack_require__(89925);
// EXTERNAL MODULE: ./store/slices/auth/index.ts + 1 modules
var auth = __webpack_require__(43685);
;// CONCATENATED MODULE: ./lib/mutation/listing/hook.ts


var useListing = function useListing() {
  var _useMutation = (0,useMutation/* useMutation */.D)(function (args) {
    return axios/* api.post */.h.post('/add-listing-price', {
      list_price: args.list_price,
      transBrokerComp: args.transBrokerComp,
      address: args.address
    }, {
      headers: {
        Authorization: "Bearer ".concat(args.jwt)
      }
    }).then(function (res) {
      return res.data;
    });
  }),
      isError = _useMutation.isError,
      isLoading = _useMutation.isLoading,
      data = _useMutation.data,
      mutateAsync = _useMutation.mutateAsync,
      error = _useMutation.error;

  return {
    sendListing: mutateAsync,
    isError: isError,
    isLoading: isLoading,
    data: data,
    error: error
  };
};
;// CONCATENATED MODULE: ./lib/mutation/listing/index.ts


// EXTERNAL MODULE: ./constants/routes.ts
var routes = __webpack_require__(71624);
;// CONCATENATED MODULE: ./components/forms/list-price-form/ConfirmForm.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















function ConfirmForm() {
  var _error$response, _errorListing$respons;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      checked = _useState[0],
      setChecked = _useState[1];

  var _useAppSelector = (0,useRedux/* useAppSelector */.C)(onboardingSelector),
      newUser = _useAppSelector.newUser,
      listing = _useAppSelector.listing;

  var dispatch = (0,useRedux/* useAppDispatch */.T)();

  var _useSignUp = useSignUp(),
      isError = _useSignUp.isError,
      error = _useSignUp.error,
      isLoading = _useSignUp.isLoading,
      signUp = _useSignUp.signUp;

  var _useListing = useListing(),
      isErrorListing = _useListing.isError,
      errorListing = _useListing.error,
      isLoadingListing = _useListing.isLoading,
      sendListing = _useListing.sendListing;

  var onSubmit = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      var _yield$signUp, jwt, user;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              _context.prev = 1;
              _context.next = 4;
              return signUp(newUser);

            case 4:
              _yield$signUp = _context.sent;
              jwt = _yield$signUp.jwt;
              user = _yield$signUp.user;
              _context.next = 9;
              return sendListing({
                list_price: listing === null || listing === void 0 ? void 0 : listing.listPrice,
                transBrokerComp: listing === null || listing === void 0 ? void 0 : listing.agentCommission,
                address: newUser === null || newUser === void 0 ? void 0 : newUser.address,
                jwt: jwt.access
              });

            case 9:
              /* eslint-enable */
              dispatch((0,onboarding/* resetOnboarding */.Ye)());
              dispatch((0,auth.addUser)({
                data: user,
                jwt: _objectSpread(_objectSpread({}, jwt), {}, {
                  access: "Bearer ".concat(jwt.access)
                })
              }));
              router.replace(routes/* HOME_ROUTE */.ef);
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 14]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [newUser, signUp, dispatch, sendListing, listing, router]);

  function handleCheckboxChange(e) {
    setChecked(e.target.checked);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PriceFormHead, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/static/icons/listing-2.svg",
        width: 100,
        height: 100
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(title/* default */.Z, {
        type: "mode3",
        fw: "light",
        className: "price-form-title",
        children: "One Step Closer to"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(title/* default */.Z, {
        type: "mode3",
        fw: "bold",
        className: "price-form-subtitle",
        children: "Selling Your Home"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
        className: "price-form-info",
        children: "Please review and accept our Terms & Conditions, Privacy Policy, Affiliated Business Disclosure, and our Cancel Anytime Agreement."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Confirm, {
      onSubmit: onSubmit,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "checkbox-wrapper",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          className: "checkbox",
          htmlFor: "confirm-form-checkbox",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "checkbox",
            checked: checked,
            id: "confirm-form-checkbox",
            onChange: handleCheckboxChange
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "checkmark"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(common_text/* default */.Z, {
          type: "mode8",
          children: ["By listing your home you accept our", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://richr.com/blog/terms-of-service/",
            target: "_blank",
            rel: "noreferrer",
            children: "Terms and Conditions"
          }), ",", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://richr.com/blog/privacy-policy/",
            target: "_blank",
            rel: "noreferrer",
            children: "Privacy Policy"
          }), ",", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://backend-stage.richr.com/api/preview-agreements/?type_pdf=affiliated&address=".concat(newUser === null || newUser === void 0 ? void 0 : newUser.address, "&list_price=").concat(listing === null || listing === void 0 ? void 0 : listing.listPrice, "&transBrokerComp=").concat(listing === null || listing === void 0 ? void 0 : listing.agentCommission, "&full_name=").concat(newUser === null || newUser === void 0 ? void 0 : newUser.fullName),
            target: "_blank",
            rel: "noreferrer",
            children: "Affiliated Business Disclosure"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://backend-stage.richr.com/api/preview-agreements/?type_pdf=limited&address=".concat(newUser === null || newUser === void 0 ? void 0 : newUser.address, "&list_price=").concat(listing === null || listing === void 0 ? void 0 : listing.listPrice, "&transBrokerComp=").concat(listing === null || listing === void 0 ? void 0 : listing.agentCommission, "&full_name=").concat(newUser === null || newUser === void 0 ? void 0 : newUser.fullName),
            target: "_blank",
            rel: "noreferrer",
            children: "Listing Agreement"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_button/* Button */.z, {
        type: "submit",
        className: "submit",
        disabled: !checked,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
          type: "mode4",
          children: "Review and Accept"
        })
      }), isError && /*#__PURE__*/(0,jsx_runtime.jsx)(common_error/* default */.Z, {
        data: error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data.errors
      }), isErrorListing && /*#__PURE__*/(0,jsx_runtime.jsx)(common_error/* default */.Z, {
        data: errorListing === null || errorListing === void 0 ? void 0 : (_errorListing$respons = errorListing.response) === null || _errorListing$respons === void 0 ? void 0 : _errorListing$respons.data.errors
      })]
    }), (isLoading || isLoadingListing) && /*#__PURE__*/(0,jsx_runtime.jsx)(loader/* PageLoader */.w, {})]
  });
}

var Confirm = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "ConfirmForm__Confirm",
  componentId: "sc-93t4k2-0"
})([".checkbox-wrapper{display:flex;align-items:flex-start;> p{margin-left:16px;text-align:left;> a{color:", ";text-decoration:underline;margin:0 5px;}}.checkbox{display:block;position:relative;padding-left:36px;cursor:pointer;font-size:22px;user-select:none;input{position:absolute;opacity:0;cursor:pointer;height:0;width:0;&:checked ~ .checkmark{background-color:", ";}&:checked ~ .checkmark:after{display:block;}}.checkmark{position:absolute;top:8px;left:0;height:24px;width:24px;background-color:", ";border:1px solid ", ";&::after{content:'';position:absolute;display:none;left:8px;top:3px;width:5px;height:10px;border:solid white;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);}}}}.submit{margin-top:36px;border-radius:unset;max-width:342px;margin:0 auto;margin-top:36px;> p{letter-spacing:2px;}&:disabled{opacity:0.4;}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.green;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.green;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.gray;
});
/* harmony default export */ var list_price_form_ConfirmForm = (/*#__PURE__*/(0,react.memo)(ConfirmForm));
;// CONCATENATED MODULE: ./data/listing-persons.json
var listing_persons_namespaceObject = JSON.parse('[{"name":"Rachael Robinson","description":"Absolutely wonderful experience listing a rental home in Panama City, FL for sale with Richr. The Richr team (especially Serena) was wonderful to work with - they responded quickly, even on nights and weekends. When the buyer agent wanted specific forms used, Richr provided us the current Florida forms to complete.","picture":"/static/icons/listing-person-1.svg"},{"name":"Madhav Mehra","description":"Serena, Wendy, and the rest of Richr team is very professional, knowledgeable and helpful.They helped us sell our house in Orlando quickly and gave excellent advice for the offers and contract paperwork.I highly recommend using Richr for selling and buying your home.","picture":"/static/icons/listing-person-2.svg"}]');
;// CONCATENATED MODULE: ./components/forms/list-price-form/ListPriceAside.tsx









function ListPriceAside() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ListPriceAsideWrapper, {
    className: "listing-aside",
    children: listing_persons_namespaceObject.map(function (person, idx) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "listing-aside-card",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: person.picture,
            width: 44,
            height: 44
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
          className: "listing-aside-card-name",
          fw: "bold",
          children: person.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: "/static/images/stars.png",
            width: 72,
            height: 14
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
          className: "listing-aside-card-desc",
          children: person.description
        })]
      }, idx);
    })
  });
}

var ListPriceAsideWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ListPriceAside__ListPriceAsideWrapper",
  componentId: "sc-737t4t-0"
})(["padding:60px 30px;background-color:", "66;width:100%;max-width:330px;display:flex;flex-direction:column;justify-content:space-between;.listing-aside{&-card{&:not(:first-child){margin-top:36px;}> p{color:", ";text-align:center;font-size:14px;}> div{display:flex;justify-content:center;}&-name{margin:8px 0;}&-desc{margin-top:16px;}}}@media ", "{max-width:100%;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.black;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, breakpoints/* device.smallLaptop */.U.smallLaptop);
/* harmony default export */ var list_price_form_ListPriceAside = (/*#__PURE__*/(0,react.memo)(ListPriceAside));
;// CONCATENATED MODULE: ./components/forms/list-price-form/ListPriceTemplate.tsx













function ListPriceTemplate(_ref) {
  var children = _ref.children,
      lastStep = _ref.lastStep;
  var dispatch = (0,useRedux/* useAppDispatch */.T)();

  var _useAppSelector = (0,useRedux/* useAppSelector */.C)(onboardingSelector),
      step = _useAppSelector.step;

  function handleStepChange() {
    dispatch((0,onboarding/* changeStep */.sz)(step === 'stepConfirm' ? 'stepListPrice' : 'stepUser'));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ListPriceTemplateWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(list_price_form_ListPriceAside, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('listing-box', {
        alt: lastStep
      }),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "listing-box-google",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/static/icons/google-mark.svg",
          width: 85,
          height: 120
        })
      }), step !== 'stepUser' && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "listing-box-back",
        onClick: handleStepChange,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/static/icons/arrow-left.svg",
          width: 24,
          height: 24
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
          children: " Back "
        })]
      }), children]
    })]
  });
}

var ListPriceTemplateWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ListPriceTemplate__ListPriceTemplateWrapper",
  componentId: "sc-crjzfv-0"
})(["display:flex;justify-content:center;padding:0 24px;transition:all 200ms ease;.listing-box{margin-left:36px;padding:70px 120px;background-color:", ";position:relative;z-index:1;width:100%;max-width:688px;&-google{position:absolute;left:36px;top:-1px;z-index:2;}&.alt{padding:48px 32px;}&-back{cursor:pointer;display:flex;align-items:center;position:absolute;z-index:2;right:24px;top:24px;> p{margin-left:4px;}}}@media ", "{flex-direction:column-reverse;padding:0;.listing-box{margin-left:0;max-width:100%;padding:48px 32px;text-align:center;&-google{left:24px;img{height:80px !important;width:80px !important;}}}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, breakpoints/* device.smallLaptop */.U.smallLaptop);
/* harmony default export */ var list_price_form_ListPriceTemplate = (/*#__PURE__*/(0,react.memo)(ListPriceTemplate));
;// CONCATENATED MODULE: ./components/common/redirect/index.tsx




function Redirect(_ref) {
  var push = _ref.push,
      replace = _ref.replace,
      _ref$pathname = _ref.pathname,
      pathname = _ref$pathname === void 0 ? routes/* HOME_ROUTE */.ef : _ref$pathname;
  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    if (push) {
      router.push(pathname);
    }

    if (replace) {
      router.replace(pathname);
    }
  }, [router, pathname, push, replace]);
  return null;
}

/* harmony default export */ var redirect = (Redirect);
// EXTERNAL MODULE: ./components/layout/auth-layout/styles.ts
var styles = __webpack_require__(70296);
;// CONCATENATED MODULE: ./components/forms/sign-up-form/styles.ts


var SignUpFormWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__SignUpFormWrapper",
  componentId: "sc-swa4fp-0"
})(["width:80%;margin:0 auto;.sign-up{&_title{margin-bottom:8px;}&-subtitle,&-address{margin-bottom:24px;}&-title,&-subtitle,&-address{color:", ";text-align:center;}}.or-line{margin:24px 0;color:", ";display:flex;justify-content:space-between;align-items:center;text-align:center;> span{width:25%;border:1px solid ", ";}}.bottom-text{padding-top:24px;> p{color:", ";}}@media ", "{width:100%;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grayPallet1;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grayPallet1;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.whitePallet1;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.gray;
}, breakpoints/* device.tablet */.U.tablet);
var SignUpWithCredentialsForm = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "styles__SignUpWithCredentialsForm",
  componentId: "sc-swa4fp-1"
})(["> button{margin-top:24px;}"]);
var SignUpWithGoogleFormWrapper = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "styles__SignUpWithGoogleFormWrapper",
  componentId: "sc-swa4fp-2"
})([".and{margin:12px 0;color:", ";text-align:center;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.gray;
});
// EXTERNAL MODULE: ./components/common/text-field/index.tsx
var text_field = __webpack_require__(80367);
// EXTERNAL MODULE: ./components/common/text-field-password/index.tsx
var text_field_password = __webpack_require__(93546);
// EXTERNAL MODULE: ./components/common/text-field-phone/index.tsx
var text_field_phone = __webpack_require__(73480);
// EXTERNAL MODULE: ./components/google-places/useGooglePlaces.ts
var useGooglePlaces = __webpack_require__(97652);
// EXTERNAL MODULE: ./components/common/select/index.tsx
var common_select = __webpack_require__(39659);
;// CONCATENATED MODULE: ./components/forms/sign-up-form/SignUpWithCredentials.tsx





















function SignUpWithCredentials() {
  var _useRouter = (0,next_router.useRouter)(),
      query = _useRouter.query;

  var dispatch = (0,useRedux/* useAppDispatch */.T)();

  var _useAppSelector = (0,useRedux/* useAppSelector */.C)(onboardingSelector),
      newUser = _useAppSelector.newUser;

  var _useForm = (0,index_esm/* useForm */.cI)({
    mode: 'onChange',
    resolver: (0,yup/* yupResolver */.X)(validations/* signUpSchema */.JJ)
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors,
      control = _useForm.control;

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var fullAddress, addressObj;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fullAddress = query.address;
              _context.prev = 1;

              if (!(typeof fullAddress === 'string')) {
                _context.next = 8;
                break;
              }

              _context.next = 5;
              return (0,useGooglePlaces/* getAddressObj */.c)(fullAddress);

            case 5:
              addressObj = _context.sent;
              dispatch((0,onboarding/* fillNewUser */.Fu)({
                email: data.signUpEmail,
                fullName: "".concat(data.signUpFirstName, " ").concat(data.signUpLastName),
                password: data.signUpPassword,
                phoneNumber: data.signUpPhone.split('-').join(''),
                usagePurpose: data.signUpUsagePurpose,
                address: fullAddress,
                addressObj: addressObj
              }));
              dispatch((0,onboarding/* changeStep */.sz)('stepListPrice'));

            case 8:
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SignUpWithCredentialsForm, {
    onSubmit: handleSubmit(onSubmit),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(text_field/* default */.ZP, {
      type: "text",
      name: "signUpEmail",
      label: "Email",
      register: register,
      error: errors.signUpEmail,
      placeholder: "Enter your email",
      initialValue: newUser === null || newUser === void 0 ? void 0 : newUser.email
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(text_field/* default */.ZP, {
      type: "text",
      name: "signUpFirstName",
      label: "First name",
      register: register,
      error: errors.signUpFirstName,
      placeholder: "Enter your first name",
      initialValue: newUser === null || newUser === void 0 ? void 0 : newUser.fullName.split(' ')[0]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(text_field/* default */.ZP, {
      type: "text",
      name: "signUpLastName",
      label: "Last name",
      register: register,
      error: errors.signUpLastName,
      placeholder: "Enter your last name",
      initialValue: newUser === null || newUser === void 0 ? void 0 : newUser.fullName.split(' ')[1]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(text_field_phone/* default */.Z, {
      control: control,
      name: "signUpPhone",
      label: "Phone",
      error: errors.signUpPhone,
      initialValue: newUser === null || newUser === void 0 ? void 0 : newUser.phoneNumber
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(text_field_password/* default */.Z, {
      type: "password",
      name: "signUpPassword",
      label: "Password",
      register: register,
      error: errors.signUpPassword,
      placeholder: "Enter your password",
      initialValue: newUser === null || newUser === void 0 ? void 0 : newUser.password
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_select/* default */.Z, {
      control: control,
      name: "signUpUsagePurpose",
      label: "How would you like to use Richr",
      error: errors.signUpUsagePurpose,
      initialValue: newUser === null || newUser === void 0 ? void 0 : newUser.usagePurpose
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_button/* Button */.z, {
      type: "submit",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
        type: "mode3",
        textTransform: "uppercase",
        children: "Sign Up"
      })
    })]
  });
}

/* harmony default export */ var sign_up_form_SignUpWithCredentials = (/*#__PURE__*/(0,react.memo)(SignUpWithCredentials));
// EXTERNAL MODULE: ./lib/mutation/google/index.ts + 1 modules
var google = __webpack_require__(66598);
;// CONCATENATED MODULE: ./components/forms/sign-up-form/SignUpWithGoogle.tsx


















function SignUpWithGoogle() {
  var _errGoogle$response;

  var _useForm = (0,index_esm/* useForm */.cI)({
    mode: 'onChange',
    resolver: (0,yup/* yupResolver */.X)(validations/* signUpWithGoogleSchema */.aF)
  }),
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors,
      control = _useForm.control,
      watch = _useForm.watch;

  var _useHandleWithGoogle = (0,google.useHandleWithGoogle)({
    usagePurpose: watch('signUpGoogleUsagePurpose'),
    phone: watch('signUpGooglePhone')
  }),
      errGoogle = _useHandleWithGoogle.error,
      isErrGoogle = _useHandleWithGoogle.isError,
      loading = _useHandleWithGoogle.loading,
      handleGoogle = _useHandleWithGoogle.handleGoogle;

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              handleGoogle();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SignUpWithGoogleFormWrapper, {
    onSubmit: handleSubmit(onSubmit),
    children: [isErrGoogle && /*#__PURE__*/(0,jsx_runtime.jsx)(common_error/* default */.Z, {
      data: errGoogle === null || errGoogle === void 0 ? void 0 : (_errGoogle$response = errGoogle.response) === null || _errGoogle$response === void 0 ? void 0 : _errGoogle$response.data.errors
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_select/* default */.Z, {
      control: control,
      name: "signUpGoogleUsagePurpose",
      label: "Choose how would you like to use Richr",
      error: errors.signUpGoogleUsagePurpose
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(text_field_phone/* default */.Z, {
      control: control,
      name: "signUpGooglePhone",
      label: "Phone",
      error: errors.signUpGooglePhone
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
      type: "mode2",
      className: "and",
      fw: "light",
      children: "and"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(common_button/* Button */.z, {
      type: "submit",
      mode: "google",
      className: "sign-in-form-google",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/static/icons/google.svg",
        width: 24,
        height: 24
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
        children: "Continue with Google"
      })]
    }), loading && /*#__PURE__*/(0,jsx_runtime.jsx)(loader/* PageLoader */.w, {})]
  });
}

/* harmony default export */ var sign_up_form_SignUpWithGoogle = (/*#__PURE__*/(0,react.memo)(SignUpWithGoogle));
;// CONCATENATED MODULE: ./components/forms/sign-up-form/index.tsx












function SignUpForm() {
  var _useRouter = (0,next_router.useRouter)(),
      query = _useRouter.query;

  return typeof query.address === 'string' && query.address ? /*#__PURE__*/(0,jsx_runtime.jsx)(styles/* AuthContent */.p, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SignUpFormWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(title/* default */.Z, {
        type: "mode1",
        fw: "light",
        className: "sign-up-title",
        children: "One Step Closer to"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(title/* default */.Z, {
        type: "mode1",
        fw: "bold",
        className: "sign-up-subtitle",
        children: "Selling Your Home"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
        type: "mode4",
        fw: "bold",
        className: "sign-up-address",
        children: "\"".concat(query.address, "\"")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(sign_up_form_SignUpWithGoogle, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(common_text/* default */.Z, {
        className: "or-line",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {}), "Or Enter Your Details Below", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(sign_up_form_SignUpWithCredentials, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "bottom-text",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(common_text/* default */.Z, {
          fw: "light",
          type: "mode2",
          children: "By signing up to Richr, you consent and agree that Richr and its affiliates may use automated technology, including pre-recorded messages, cell phones, and texts, and email to contact you at the number and email address you provided. This includes if your number is currently on any Do Not Call Lists. Consent is not required to make a purchase. Message and data rates may apply. You also agree to Our Terms of Service."
        })
      })]
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(redirect, {
    pathname: "/",
    replace: true
  });
}

/* harmony default export */ var sign_up_form = (/*#__PURE__*/(0,react.memo)(SignUpForm));
// EXTERNAL MODULE: ./components/layout/auth-layout/index.tsx
var auth_layout = __webpack_require__(72943);
;// CONCATENATED MODULE: ./pages/auth/sign-up/index.tsx













function SignUpPage() {
  var _useAppSelector = (0,useRedux/* useAppSelector */.C)(onboardingSelector),
      step = _useAppSelector.step;

  var dispatch = (0,useRedux/* useAppDispatch */.T)();
  (0,react.useEffect)(function () {
    return function () {
      dispatch((0,onboarding/* resetOnboarding */.Ye)());
    };
  }, [dispatch]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(auth_layout/* default */.Z, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Sign-Up"
      })
    }), step === 'stepUser' && /*#__PURE__*/(0,jsx_runtime.jsx)(sign_up_form, {}), step === 'stepListPrice' && /*#__PURE__*/(0,jsx_runtime.jsx)(list_price_form_ListPriceTemplate, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(list_price_form_PriceForm, {})
    }), step === 'stepConfirm' && /*#__PURE__*/(0,jsx_runtime.jsx)(list_price_form_ListPriceTemplate, {
      lastStep: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(list_price_form_ConfirmForm, {})
    })]
  });
}

/* harmony default export */ var sign_up = (SignUpPage);

/***/ }),

/***/ 81326:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/sign-up",
      function () {
        return __webpack_require__(699);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,7536,8074,9491,8837,5138,7333,7848,8664,2486,9774,2888,179], function() { return __webpack_exec__(81326); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);